import { render } from "./z-button.vue?vue&type=template&id=23178b9c"
import script from "./z-button.vue?vue&type=script&lang=js"
export * from "./z-button.vue?vue&type=script&lang=js"

import "./z-button.vue?vue&type=style&index=0&id=23178b9c&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__